let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("30qJQ")).then(() => parcelRequire('5b13K'));